import BarChart from './BarChart.jsx';

function PopulationLocationChart({ data }) {
  const options = {
    xaxis: {
      categories: ['Мужчины', 'Женщины', 'Общая численность населения'],
    },
  };

  const series = [
    {
      name: 'Городское население, чел',
      data: [
        data.urban_male_population,
        data.urban_female_population,
        data.urban_population,
      ],
    },
    {
      name: 'Сельское население, чел',
      data: [
        data.rural_male_population,
        data.rural_female_population,
        data.rural_population,
      ],
    },
  ];

  return (
    <BarChart
      series={series}
      options={options}
      stacked
      title="Население по полу и месту проживания, человек"
    />
  );
}

export default PopulationLocationChart;
